// File: src/pages/Contact.jsx
import React, { useState } from "react";
import { supabase } from "../utils/supabaseClient";
import "./Contact.css";

export default function Contact() {
  const [org, setOrg] = useState("");
  const [website, setWebsite] = useState("");
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [notes, setNotes] = useState("");

  const [loading, setLoading] = useState(false);
  const [feedback, setFeedback] = useState(null);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setFeedback(null);

    if (!org || !email || !name) {
      setLoading(false);
      alert("Please fill in the required fields (Organization, Name, Email).");
      return;
    }

    try {
      const client = supabase;
      if (!client) throw new Error("supabase missing");
      const { error } = await client.from("inbound_requests").insert([
        {
          organization: org,
          website,
          contact_name: name,
          contact_email: email,
          notes,
        },
      ]);
      if (error) throw error;
      setFeedback("success");
      setOrg(""); setWebsite(""); setName(""); setEmail(""); setNotes("");
    } catch (err) {
      const body = encodeURIComponent(
        `Organization: ${org}\nWebsite: ${website}\nName: ${name}\nEmail: ${email}\nNotes: ${notes}`
      );
      window.location.href = `mailto:adcheng4@illinois.edu?subject=PanelZero%20demo%20request&body=${body}`;
      setFeedback("success");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="sales-page-container">
      <div className="sales-content-wrapper">
        <div className="sales-info">
          <h1 className="sales-title">Stop writing appeals by hand.</h1>

          <div className="sales-description">
            <p>
              Tell us about your denial volume and EHR, and we&apos;ll come back within one business day with
              a revenue-recovery estimate based on your data. Demos are 30 minutes, no slides — just the live
              product running against a sample of your denials.
            </p>
            {/* Restore when hello@panelzero.com is live:
            <p>
              Prefer email? <a href="mailto:hello@panelzero.com">hello@panelzero.com</a>.
            </p>
            */}
          </div>

          <div
            className="sales-comparison"
            style={{
              marginTop: "var(--testimonial-margin-top)",
              borderTop: "1px solid #e5e7eb",
              paddingTop: "2rem",
            }}
          >
            <div style={{ marginBottom: "1.5rem" }}>
              <h4 style={{ fontSize: "0.85rem", textTransform: "uppercase", color: "#0e8a8a", fontWeight: 700, letterSpacing: "0.05em", marginBottom: "0.5rem" }}>
                With PanelZero
              </h4>
              <p style={{ fontSize: "1rem", color: "#111827", margin: 0, fontWeight: 500 }}>
                Every denial arrives in the queue as a drafted appeal — payer-specific language, chart evidence attached, ready to submit.
              </p>
            </div>

            <div>
              <h4 style={{ fontSize: "0.85rem", textTransform: "uppercase", color: "#ef4444", fontWeight: 700, letterSpacing: "0.05em", marginBottom: "0.5rem" }}>
                The old way
              </h4>
              <p style={{ fontSize: "1rem", color: "#6b7280", margin: 0 }}>
                Biller opens each denial, hunts the chart, rewrites the same paragraph for the tenth time this week, faxes a PDF.
              </p>
            </div>
          </div>
        </div>

        <div className="sales-form-section">
          <h3 className="form-heading">Tell us about your organization</h3>

          <form className="contact-form" onSubmit={handleSubmit}>
            <label htmlFor="org">Hospital / practice name</label>
            <input
              id="org"
              type="text"
              placeholder="Your organization"
              value={org}
              onChange={(e) => setOrg(e.target.value)}
              required
            />

            <label htmlFor="website">Website</label>
            <input
              id="website"
              type="text"
              placeholder="https://yourpractice.com"
              value={website}
              onChange={(e) => setWebsite(e.target.value)}
            />

            <div className="form-row-split">
              <div className="form-group">
                <label htmlFor="name">Contact name</label>
                <input
                  id="name"
                  type="text"
                  placeholder="Your name"
                  value={name}
                  onChange={(e) => setName(e.target.value)}
                  required
                />
              </div>

              <div className="form-group">
                <label htmlFor="email">Work email</label>
                <input
                  id="email"
                  type="email"
                  placeholder="you@yourpractice.com"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required
                />
              </div>
            </div>

            <label htmlFor="notes">EHR + denial volume (optional)</label>
            <textarea
              id="notes"
              rows="5"
              placeholder="e.g. Epic and ~$1.8M/month, or athenahealth and ~$120K/month. Top reasons: prior auth and medical necessity."
              value={notes}
              onChange={(e) => setNotes(e.target.value)}
            />

            <button
              type="submit"
              className="contact-button"
              disabled={loading || feedback === "success"}
            >
              {loading ? "Sending..." : feedback === "success" ? "Request sent!" : "Request demo"}
            </button>

            {feedback === "success" && (
              <p className="contact-success">Thanks — we&apos;ll be in touch within one business day.</p>
            )}
            {feedback === "error" && (
              <p className="contact-error">Something went wrong. Please try again.</p>
            )}
          </form>
        </div>
      </div>
    </div>
  );
}
